import React, { useEffect, useRef } from "react";
import EmojiPicker, { EmojiClickData, Theme } from "emoji-picker-react";
import { BiSmile } from "react-icons/bi";
import { useSelector } from "react-redux";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { CiUser } from "react-icons/ci";

type UserFeedCommentPostProps = {
  textArea: React.MutableRefObject<HTMLTextAreaElement | null>;
  handleSubmit: any;
  userComment: any;
  setUserComment: React.Dispatch<React.SetStateAction<string>>;
  loading: boolean;
};

const UserFeedCommentPost: React.FC<UserFeedCommentPostProps> = ({
  textArea,
  handleSubmit,
  loading,
  setUserComment,
  userComment,
}) => {
  const [onChange, setOnChange] = React.useState(false);
  const [openEmojiPicker, setOpenEmojiPicker] = React.useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const onClick = (emojiData: EmojiClickData) => {
    setUserComment(
      (inputValue) =>
        inputValue + (emojiData.isCustom ? emojiData.unified : emojiData.emoji)
    );
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpenEmojiPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const inputValue = e.target.value;
    setUserComment(inputValue);
    setOnChange(inputValue.trim().length > 0);
  };
  const user = useSelector((state: any) => state.user.userDetails);
  let pImage: string | null = "";

  if (
    user &&
    user?.ecobookProfile &&
    user.ecobookProfile?.profileImage !== null
  ) {
    const profilePic = user?.ecobookProfile?.profileImage;

    if (profilePic !== null && profilePic !== undefined) {
      pImage = profilePic;
    }
  }
  return (
    <div className="relative hidden w-full h-32 lg:flex justify-between bg-white p-6 shadow-[1px_-1px_8px_2px_rgba(0,0,0,0.1)]">
      <div className="w-10 h-10">
      {pImage ?<img
          src={ipfsGatewayImage(pImage!)}
          alt=""
          className="w-10 h-10 rounded-full"
        />: (
          <div className="w-10 h-10 bg-slate-100 flex items-center justify-center rounded-full">
            <CiUser size={15} />
          </div>
        )}      </div>
      <form
        className="w-[90%] h-24 flex justify-between"
        onSubmit={handleSubmit}
      >
        <textarea
          ref={textArea}
          placeholder="Add a comment..."
          value={userComment}
          onChange={handleOnChange}
          className={`outline-none rounded-lg border border-solid border-[#F4F4F4] h-24 w-[75%] pt-3 px-9 text-sm font-NotoSans resize-none ${
            loading ? "disabled:bg-blend-overlay" : ""
          }`}
          required
          disabled={loading}
        />
        {!loading && (
          <button
            type="submit"
            className={`w-[104px] absolute right-6 top-6 h-12 p-3 text-sm font-Poppins rounded text-white font-medium ${
              onChange
                ? "bg-midGreen cursor-pointer active:w-[99px] active:mb-px"
                : "bg-greyText cursor-not-allowed text-lightGreen"
            }`}
          >
            SEND
          </button>
        )}
        :
        {loading && (
          <button
            disabled
            className="w-[104px] h-12 p-3 absolute right-6 top-6 bg-greyText text-lightGreen text-sm font-Poppins rounded shadow cursor-progress"
          >
            SEND
          </button>
        )}
      </form>

      <div className="absolute left-[95px] top-[37px]">
        <BiSmile
          size={20}
          className="cursor-pointer active:fill-red-200"
          onClick={() => setOpenEmojiPicker(!openEmojiPicker)}
        />
      </div>
      {openEmojiPicker && (
        <div
          className="absolute bottom-28 ease-in-out duration-75 w-[60%] rounded text-[9px] font-Poppins"
          ref={containerRef}
        >
          <EmojiPicker
            onEmojiClick={onClick}
            height={300}
            theme={Theme.AUTO}
            previewConfig={{
              showPreview: false,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default UserFeedCommentPost;
